import { render, staticRenderFns } from "./Mappa.vue?vue&type=template&id=a866d06c&"
import script from "./Mappa.vue?vue&type=script&lang=js&"
export * from "./Mappa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports